<template>
  <div class="d-flex text-center justify-center align-center fullscreen">
    <slot>
      <Loading />

      <Suspense>
        <div>
          <router-view v-slot="{ Component }">
            <component :is="Component" />
          </router-view>
        </div>
      </Suspense>
    </slot>
  </div>
</template>

<script setup lang="ts">
import Loading from '@/components/General/AppLoading.vue'
</script>
